import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container } from "react-bootstrap";

import Loading from "../../loading/pages/Loading";
import Failed from "../../loading/pages/Failed";
import SearchBar from "../../common/components/SearchBar";
import { getRequest } from "../../api/axiosRequests";
import { useAuth } from "../../auth/hook";
import CardCompletedWorkout from "../components/CardCompletedWorkout";

export default function CompletedWorkouts() {
  const navigate = useNavigate();
  const [planDays, setPlanDays] = useState([]);
  const [filteredPlanDays, setFilteredPlanDays] = useState([]);
  const auth = useAuth();
  const user = auth.user;
  const userSubscription = auth.userSubscription;
  const [hasPermission, setHasPermission] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = planDays.filter((planDay) =>
      planDay.workout.name.toLowerCase().includes(nameLowerCase)
    );
    setFilteredPlanDays(filtered);
  };

  const fetchData = () => {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 = getRequest("userPlanDayCompleted/", headers);
    const promise2 = getRequest("userData/", headers);

    Promise.all([promise1, promise2])
      .then((values) => {
        const planDaysList = values[0]["data"];
        const role = values[1]["data"]["role"];
        setHasPermission(role === "Admin" || userSubscription.id != -1);
        setPlanDays(planDaysList);
        setFilteredPlanDays(planDaysList);
        setIsFailed(false);
        setIsLoaded(true);
      })
      .catch((err) => {
        setIsFailed(true);
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  return (
    <div>
      {!isLoaded && <Loading />}
      {isLoaded && isFailed && (
        <Failed
          separatorText={""}
          mainDescription={"Errore durante il caricamento degli allenamenti."}
        />
      )}
      {isLoaded && !isFailed && (
        <div>
          <Container className="pb-2">
            <SearchBar
              onChange={onSearchChange}
              placeholder="Tutti gli allenamenti completati"
              addButton={false}
            />
          </Container>
          <Container>
            {filteredPlanDays.length > 0 &&
              filteredPlanDays.map((planDay, idxPlanDay) => (
                <div key={idxPlanDay}>
                  <CardCompletedWorkout
                    height={80}
                    planDay={planDay}
                    isActive={true}
                  />
                </div>
              ))}

            {filteredPlanDays.length === 0 && (
              <div className="pt-5">
                <Failed
                  separatorText={""}
                  mainDescription={`Nessun allenamento completato.`}
                  secondaryDescription={""}
                  paddingTop={"0px"}
                />
              </div>
            )}
          </Container>
        </div>
      )}
    </div>
  );
}
